import {SHARED_PATIENTS_ROUTE} from "../../../routes";
import {useNavigate} from "react-router";
import {useEffect} from "react";
import {clearSavedListParams} from "../../../helpers/LocalStorageHelper";

export function SharedPatientsClear() {
    const history = useNavigate()
    useEffect(() => {
        clearSavedListParams();
        history(SHARED_PATIENTS_ROUTE, {replace: true});
    }, []);
    return <div/>
}